// src/app/page.tsx
import { FC, useState } from "react";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Modal,
  Typography,
  useTheme,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import MemoryImg from "../../../../assets/images/Memory-green.svg";
import ExpandIcon from "../../../../assets/images/Expand.svg";
import "./index.css";
import { CustomButton } from "../../../../components/Button";
import { useNavigate } from "react-router-dom";
import { ConfirmationDialog } from "../../../../components/ConfirmationDialog";

const Memory: FC = () => {
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const navigate = useNavigate();
  const modalContent = `This bot acts as my HR. Facilitates employee onboarding, manages HR
            queries, and helps with nati scheduling and feedback collection.
            This bot acts as my HR. Facilitates employee onboarding, manages HR
            queries, and helps with nati scheduling and feedback collection.
            This bot acts as my HR. Facilitates employee onboarding, manages HR
            queries, and helps with nati scheduling and feedback collection.`;

  const handleClose = () => {
    setOpen(false);
  };
  const memoryModal = () => {
    return (
      <ConfirmationDialog
        open={open}
        content={modalContent}
        title="Current Memory"
        icon={
          <div>
            <img src={MemoryImg} />
          </div>
        }
        btn1="Close"
        btn2="Manage memory"
        handleBtn1={handleClose}
        handleBtn2={() => navigate("/manage-memory")}
      />
    );
  };

  return (
    <div className="memory-section">
      <Grid container sx={{ width: "100%" }}>
        <Grid size={{ xs: 4, md: 6 }}>
          <Typography>Memory</Typography>
        </Grid>
        <Grid size={{ xs: 8, md: 6 }} display={"flex"} justifyContent={"end"}>
          <div
            className="memory-management"
            onClick={() => navigate("/manage-memory")}
          >
            <div>Manage memory </div>
            <div className="d-flex">
              <img src={MemoryImg} className="memory-img" />
            </div>
          </div>
        </Grid>
      </Grid>
      <div className="position-relative">
        <textarea
          className="personality-textarea"
          placeholder="This bot acts as my HR. Facilitates employee onboarding, manages HR queries, and helps with scheduling and feedback collection."
          style={{ backgroundColor: theme.palette.background.default }}
        ></textarea>
        <div className="expand" onClick={() => setOpen(true)}>
          <img src={ExpandIcon} />
        </div>
      </div>
      {memoryModal()}
    </div>
  );
};

export default Memory;
